import { Box, Typography, Stack } from "@mui/material";
import QuizIcon from "@mui/icons-material/Quiz";
import { useTheme } from "@mui/material/styles";

export default function PageTitle({ title, subtitle }) {
  const theme = useTheme();

  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{ mb: 6 }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"   
        justifyContent="center"
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: 1,
            background: theme.custom.gradients.bluePurple,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            boxShadow: theme.custom.shadow.soft,
          }}
        >
          <QuizIcon sx={{ fontSize: 32 }} />
        </Box>

        <Typography
          variant="h3"
          fontWeight={800}
          sx={{
            background: theme.custom.colors.grey,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: 0.8,
            lineHeight: 1, 
          }}
        >
          {title}
        </Typography>
      </Stack>

      {/* Subtitle */}
      {subtitle && (
        <Typography
          variant="body1"
          sx={{
            maxWidth: 640,
            textAlign: "center",
            color: "text.secondary",
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
}
